import {LogEvent} from '../events.js';

export class Visit extends LogEvent {
  /**
   * @param {string} user
   * @param {Amateur} amateur
   */
  constructor(user, amateur) {
    super();
    this.user = user;
    this.amateur = amateur;
    this.secs = 0;
    this.start = Date.now();
    this.type = 'Visit';
  }

  /**
   * @returns {import('../events').LogEventDTO}
   */
  getDTO() {
    const dto = super.getDTO();
    dto.amateurId = this.amateur.id;
    dto.secs = this.secs;

    return dto;
  }

  /**
   * Ends the visit and calculates the duration in seconds.
   * @returns {this} Returns the instance of the class.
   */
  endVisit() {
    this.secs = Math.round((Date.now() - this.start) / 1000);
    return this;
  }
}

export class ProfileVisit extends Visit {
  /**
   * @param {string} user
   * @param {Amateur} amateur
   */
  constructor(user, amateur) {
    super(user, amateur);
    this.type = 'ProfileVisit';
  }

  /**
   * Ends the visit, tracks the duration, and associates it with the amateur.
   * @returns {this} Returns the instance of the class.
   */
  endVisit() {
    super.endVisit();
    this.amateur.trackVisit(this.secs);
    return this;
  }
}

export class MoviesVisit extends Visit {
  /**
   * @param {string} user
   * @param {Amateur} amateur
   */
  constructor(user, amateur) {
    super(user, amateur);
    this.type = 'MoviesVisit';
  }
}
export class PicturesVisit extends Visit {
  /**
   * @param {string} user
   * @param {Amateur} amateur
   */
  constructor(user, amateur) {
    super(user, amateur);
    this.type = 'PictureVisit';
  }
}
